import type { MyBet } from '@ps/isp-web-services-types';
import { Link, Translation } from '@ps/web-shared-components';
import React from 'react';

import useBonusAction from '@swf/sports/hooks/useBonusAction';

import useTrackPromotionHistory from '../../hooks/useTrackPromotionHistory';

import { TXTWCL_Promotion_History } from './PromotionHistory.messages.json';
import styles from './PromotionHistory.scss';

interface Props {
  bet: MyBet;
  isBonusCash: boolean;
}

const PromotionHistory: React.FC<Props> = ({ bet, isBonusCash }) => {
  const trackPromotionHistory = useTrackPromotionHistory();

  const { action, path } = useBonusAction(isBonusCash);

  return (
    <span>
      {' - '}
      <Link
        className={styles.link}
        onClick={(e: React.MouseEvent<HTMLElement>) => {
          trackPromotionHistory({ bet, destinationUrl: path });
          e.preventDefault();
          action();
        }}
        track={false}
        href={path}
      >
        <Translation {...TXTWCL_Promotion_History} />
      </Link>
    </span>
  );
};

export default PromotionHistory;
